export type ContentCategory = 'poem' | 'classic' | 'radical' | 'common' | 'lyrics' | 'structure' | 'sutra' | 'calligraphy' | 'control'

export type Dynasty = 'chunqiu' | 'han' | 'weijin' | 'tang' | 'song' | 'yuan' | 'ming' | 'qing' | 'modern'

export const DYNASTY_LABELS: Record<Dynasty, string> = {
  chunqiu: '春秋戰國',
  han: '漢',
  weijin: '魏晉南北朝',
  tang: '唐',
  song: '宋',
  yuan: '元',
  ming: '明',
  qing: '清',
  modern: '現代',
}

export interface ContentItem {
  id: string
  category: ContentCategory
  dynasty: Dynasty
  title: string
  source: string
  description: string
  content: string
}

import { CHUNQIU_ARTICLES } from './dynasties/chunqiu'
import { HAN_ARTICLES } from './dynasties/han'
import { WEIJIN_ARTICLES } from './dynasties/weijin'
import { TANG_ARTICLES } from './dynasties/tang'
import { SONG_ARTICLES } from './dynasties/song'
import { YUAN_ARTICLES } from './dynasties/yuan'
import { MING_ARTICLES } from './dynasties/ming'
import { QING_ARTICLES } from './dynasties/qing'
import { MODERN_ARTICLES } from './dynasties/modern'

export const CONTENT_LIBRARY: ContentItem[] = [
  ...CHUNQIU_ARTICLES,
  ...HAN_ARTICLES,
  ...WEIJIN_ARTICLES,
  ...TANG_ARTICLES,
  ...SONG_ARTICLES,
  ...YUAN_ARTICLES,
  ...MING_ARTICLES,
  ...QING_ARTICLES,
  ...MODERN_ARTICLES,
]

export const CATEGORY_LABELS: Record<ContentCategory, string> = {
  control: '控筆練習',
  poem: '詩詞歌賦',
  classic: '經典文章',
  radical: '相同部首',
  common: '常用字例字',
  lyrics: '經典歌詞',
  structure: '間架結構32法',
  sutra: '常用抄經',
  calligraphy: '經典碑帖',
}

export function getDynastiesByCategory(category: ContentCategory): Dynasty[] {
  const set = new Set<Dynasty>()
  for (const item of CONTENT_LIBRARY) {
    if (item.category === category) set.add(item.dynasty)
  }
  const order: Dynasty[] = ['chunqiu', 'han', 'weijin', 'tang', 'song', 'yuan', 'ming', 'qing', 'modern']
  return order.filter(d => set.has(d))
}

export function getAuthorsByCategoryAndDynasty(
  category: ContentCategory,
  dynasty: Dynasty,
): string[] {
  const set = new Set<string>()
  for (const item of CONTENT_LIBRARY) {
    if (item.category === category && item.dynasty === dynasty) set.add(item.source)
  }
  return [...set]
}

export function filterItems(
  items: ContentItem[],
  category: ContentCategory | '',
  dynasty: Dynasty | '',
  author: string,
): ContentItem[] {
  return items.filter((item) => {
    if (category && item.category !== category) return false
    if (dynasty && item.dynasty !== dynasty) return false
    if (author && item.source !== author) return false
    return true
  })
}

export function generateId(category: ContentCategory, title: string): string {
  const prefix = category
  const slug = title.replace(/[·（(）.。，,、\s]/g, '').slice(0, 20)
  return `${prefix}-${slug}-${Date.now().toString(36)}`
}
